import { RecentProjectModel } from "lib/actions/recentProjects/RecentProjectModel";
import { getObjectFromLocalStorage } from "lib/actions/util/getObjectFromLocalStorage";

export function getRecentProjectsFromLocalStorage(): RecentProjectModel[] {
  const value = getObjectFromLocalStorage("recentProjects");
  if (
    !(value instanceof Array) ||
    value.some((p) => p.id == undefined || p.lastAccessed == undefined)
  ) {
    console.warn("Invalid recent projects found in local storage.");
    localStorage.removeItem("recentProjects");
    return [];
  }
  return value;
}
